import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import { useDispatch } from 'react-redux';

import { convertThumbnailToPictureImage } from '@tager/web-modules';

import { media } from '@/utils/mixin';
import Link from '@/components/Link';
import Picture from '@/components/Picture';
import { PostFull } from '@/typings/model';
import { getPostUrl } from '@/utils/posts';
import { getBookmarksThunk } from '@/store/reducers/pages/bookmarks';
import {
  getPostPreviewThunk,
  selectPostPreviewResource,
} from '@/store/reducers/pages/post';
import { useTypedSelector } from '@/store/store';

type Props = {
  id: string;
};
function WidgetSamePost({ id }: Props) {
  const dispatch = useDispatch();
  const postResource = useTypedSelector((state) =>
    selectPostPreviewResource(state, +id)
  );
  useEffect(() => {
    if (id) {
      dispatch(getPostPreviewThunk(+id));
    }
  }, []);
  if (!postResource?.data) return null;

  const post = postResource.data[0];

  if (!post) return null;
  return (
    <SamePostBlock>
      <Link to={getPostUrl(post)}>
        <Picture
          {...convertThumbnailToPictureImage(post.coverImage?.previewSmall)}
        />{' '}
      </Link>
      <Link as={Title} to={getPostUrl(post)}>
        {post.title}
      </Link>
    </SamePostBlock>
  );
}

const SamePostBlock = styled.div`
  position: absolute;
  left: 750px;
  //bottom: 4.4px;
  top: 4.4px;
  width: 270px;
  line-height: 100%;
  ${media.tabletLargeOnly(
    css`
      left: 720px;
    `
  )}
  ${media.tabletSmall(
    css`
      position: static;
      left: 0;
      margin: 20px auto;
      text-align: center;
    `
  )}
`;

const Title = styled.a`
  font-size: 14px;
  line-height: 18px;
`;

export default WidgetSamePost;
